import { Component, OnInit, isDevMode } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-quote-contact-info',
  templateUrl: './quote-contact-info.component.html',
  styleUrls: ['./quote-contact-info.component.scss']
})
export class QuoteContactInfoComponent implements OnInit {
  form!: FormGroup
  inDev = isDevMode()
  constructor(private rootFormGroup: FormGroupDirective) {    
  }

  ngOnInit() : void {
    this.form = this.rootFormGroup.control
  }
}
